import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { FiArrowUp } from 'react-icons/fi';
import { getScrollBehavior } from '@/utils/scroll';
import '../styles/footer.css';

export default function Footer() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { locale } = useParams();

  // Hidden period click handler for easter egg
  const handleHiddenClick = () => {
    navigate(`/${locale || 'en'}/beyond-code`);
  };

  // Parse copyright text to make period clickable
  const copyrightText = t('footer.copyright');
  // The text ends with a period, so we split it
  const textWithoutPeriod = copyrightText.replace(/\.$/, '');
  const hasPeriod = copyrightText.endsWith('.');

  return (
      <footer className="site-footer">
        <div className="site-footer-inner">
          <p className="site-footer-wordmark" aria-hidden="true">
            Nicholas Y<span className="site-footer-dot">.</span>
          </p>
          <div className="site-footer-row">
            <p className="site-footer-copy">
              {textWithoutPeriod}
              {hasPeriod && (
                <span
                  onClick={handleHiddenClick}
                  className="cursor-default hover:cursor-pointer hover:text-accent-link transition-colors select-none"
                  title=""
                  aria-hidden="true"
                >
                  .
                </span>
              )}
            </p>
            <button
              type="button"
              className="site-footer-top"
              onClick={() => window.scrollTo({ top: 0, behavior: getScrollBehavior() })}
              aria-label={t('footer.backToTop')}
            >
              <FiArrowUp aria-hidden="true" />
            </button>
          </div>
        </div>
      </footer>
  );
}
